module.exports = __webpack_public_path__ + "img/sliders-solid.ed7a7863.svg";